import React, { useState, useEffect, useCallback } from 'react';
import logo from './logo.svg';
import './App.css';
import { Button } from 'react-bootstrap'; 
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Route, Routes, Link } from 'react-router-dom';
import Home from './component/Home';
import HeaderView from './component/header/HeaderView';
import 'bootstrap/dist/css/bootstrap.min.css';
import BookingWrapper from './component/Booking/BookingWrapper';
import RoleList from './component/Roles/List';
import AddRole from './component/Roles/Add'; 
import UserWrapper from './component/Users/UserWrapper';
import AddUser from './component/Users/AddUser';
import Dashboard from './component/Payment/Dashboard';
import ChannelsLogWrapper from './component/Logs/ChannelsLog/ChannelsLogWrapper';
import PushDataLogWrapper from './component/Logs/PushDataLog/PushDataLogWrapper';
import ActivityLogWrapper from './component/Logs/ActivityLog/ActivityLogWrapper';
import SyncLogWrapper from './component/Logs/SyncLog/SyncLogWrapper';
import MyChannelList from './component/ChannelManager/ChannelMapping/MyChannelList';
import AllChannelList from './component/ChannelManager/ChannelMapping/AllChannelList';
import ChannelDetails from './component/ChannelManager/ChannelMapping/ChannelDetails';
import MappingWrapper from './component/ChannelManager/UploadMapping/MappingWrapper';
import DownloadMapping from './component/ChannelManager/UploadMapping/DownloadMapping';
import MarkupWrapper from './component/ChannelManager/SpecialMarkup/MarkupWrapper';
import DecreaseInventoryWrapper from './component/ChannelManager/SpecialMarkup/DecreaseInventoryWrapper';
import MarkupDaywise from './component/ChannelManager/SpecialMarkup/MarkupDaywise';
import PropertySetup from './component/Property/PropertySetup';
import RatePlanWrapper from './component/RatePlan/RatePlanWrapper';
import AddRatePlan from './component/RatePlan/AddRatePlan';
import RoomCategoryListContainer from './component/ManageRoom/RoomCategoryListContainer';
import ManageRoomContainer from './component/ManageRoom/ManageRoomContainer';
import MainInventory from './component/RateInventory/MainInventory';
import { RateInventoryDashboard } from './component/RateInventoryDashboard';
import { localStorageUtility } from './utils/utilityFunctions';
import Loader from './component/Common/Loader';
import NegativeDerivative from './component/NegativeDerivative/NegativeDerivative';
import ChannelSync from './component/ChannelSync/ChannelSync';
import BulkCharge from './component/Payment/BulkCharge';
const theme = createTheme();

function App() {
  console.log(process.env.REACT_APP_API_URL);
  
  const [identity, setIdentity] = useState(localStorageUtility.fetch('identity'));
  // Simulate getIdentity with a timeout for 3 seconds if identity is not present
  const getIdentity = useCallback(() => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const identityVal = localStorageUtility.fetch('identity');
        if (identityVal !== null) {
          resolve(identityVal);
        } else {
          reject(null);
        }
      }, 3000);
    });
  }, []);

  useEffect(() => {
    if (identity === null) {
      getIdentity()
        .then((id) => setIdentity(id))
        .catch(() => setIdentity(null));
    }
  }, [identity, getIdentity]);

  
  return (
    <div className="App">
       {identity !== null
       ?
      <main>
        <HeaderView />
        <div className="margtop55">
          <Routes>
            <Route path="/" element={<BookingWrapper />} />
            <Route path="/roles" element={<RoleList />} />
            <Route path="/add_role" element={<AddRole />} />
            <Route path="/add_role/:id/:type?" element={<AddRole />} />
            <Route path="/users" element={<UserWrapper />} />
            <Route path="/user/edit/:id" element={<AddUser />} />
            <Route path="/payment/dashboard" element={<Dashboard />} />
            <Route path="/log/channellog" element={<ChannelsLogWrapper />} />
            <Route path="/log/pushdatalog" element={<PushDataLogWrapper />} />
            <Route path="/log/activitylog" element={<ActivityLogWrapper />} />
            <Route path="/log/pmslog" element={<SyncLogWrapper />} />
            <Route path="/log/synclog" element={<SyncLogWrapper />} />
            <Route path="/channelmanager/mychannel" element={<MyChannelList />} />
            <Route path="/channelmanager/allchannel" element={<AllChannelList />} />
            <Route path="/channelmanager/mychannel/channeldetails/:channelDetail" element={<ChannelDetails />} />
            <Route path="/channelmanager/uploadmapping" element={<MappingWrapper />} />
            <Route path="/channelmanager/mapping/download" element={<DownloadMapping />} />
            <Route path="/channelmanager/markup" element={<MarkupWrapper />} />
            <Route path="/channelmanager/decreaseinventory" element={<DecreaseInventoryWrapper />} />
            <Route path="/channelmanager/markup_daywise" element={<MarkupDaywise />} />
            <Route path="/property/setup/:hotelId" element={<PropertySetup />} />
            <Route path="/rateplan" element={<RatePlanWrapper />} />
            <Route path="/rateplan/editrateplan/:rpId" element={<AddRatePlan />} />
            <Route path="/roomcategory" element={<RoomCategoryListContainer />} />
            <Route path="/roomcategory/manage/:room_category_id?" element={<ManageRoomContainer/>} />
            <Route path="/rate-inventory" element={<RateInventoryDashboard />} />
            <Route path="/rate-inventory/main" element={<MainInventory />} />
            <Route path="/channelmanager/negative_derivative" element={<NegativeDerivative />} />
            <Route path="/channelmanager/sync" element={<ChannelSync />} />
            <Route path="/payment/bulk_charge" element={<BulkCharge />} />
            {/* Fallback route for unmatched paths */}
            <Route path="*" element={<BookingWrapper />} />
          </Routes>
        </div>
        {/* <footer className="App-footer">
          <p>Footer content here</p>
        </footer>  */}
      </main>
       : <Loader />}
    </div>
  );
}

export default App;
